import { Component, OnInit } from '@angular/core';
import { ListViewModeService } from './list-view-mode.service';

@Component({
  selector: 'list-view-mode',
  templateUrl: './list-view-mode.component.html',
  styleUrl: './list-view-mode.component.scss',
  standalone: false,
})
export class ListViewModeComponent implements OnInit {
  isCompact$ = this.listViewModeService.getStatus();

  constructor(private listViewModeService: ListViewModeService) {}

  ngOnInit(): void {
    this.listViewModeService.loadViewMode();
  }

  changeViewMode(status: boolean) {
    this.listViewModeService.setStatus(status);
  }
}
